import { render, staticRenderFns } from "./TemplatesManagement.vue?vue&type=template&id=0cf0b6d6&scoped=true&"
import script from "./TemplatesManagement.vue?vue&type=script&lang=js&"
export * from "./TemplatesManagement.vue?vue&type=script&lang=js&"
import style0 from "./TemplatesManagement.vue?vue&type=style&index=0&id=0cf0b6d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf0b6d6",
  null
  
)

export default component.exports